import React, { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
  ButtonColorTypes,
} from "../shared-components/Button";
import Divider from "../shared-components/LineDivider";
import { uniqueUUID } from "../utils";
import { PersonFormStateError } from "./PersonFormErrorState";

import PersonFormAddressField from "./PersonFormAddressField";

export interface AddressesDefinitions {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  key: string;
  completed?: string;
}

type Props = {
  onChange?: (aliases: AddressesDefinitions[]) => void;
  error?: PersonFormStateError;
  prefill?: AddressesDefinitions[];
  alternateColor?: boolean;
};

function buildEmptyDefinition(): AddressesDefinitions {
  return {
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    completed: "",
    key: uniqueUUID(),
  };
}
const PersonFormAddresses = ({
  onChange,
  error,
  prefill,
  alternateColor,
}: Props) => {
  const [fieldsList, setFields] = useState<AddressesDefinitions[]>([]);

  const appendFields = () => {
    handleChange([...fieldsList, buildEmptyDefinition()]);
  };

  const removeField = (idx: number) => {
    fieldsList.splice(idx, 1);
    handleChange([...fieldsList]);
  };

  const handleChange = (list: AddressesDefinitions[]) => {
    onChange?.(list);
    setFields(list);
  };

  useEffect(() => {
    if (prefill && prefill.length > 0) {
      handleChange([...prefill]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  const handleAdd = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    appendFields();
  };

  const handleRemove = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    idx: number
  ) => {
    e.preventDefault();
    removeField(idx);
  };
  return (
    <>
      {fieldsList.map((fields, idx) => (
        <div key={fields.key} className="flex flex-wrap">
          <PersonFormAddressField
            prefill={fields}
            onChange={(address) => {
              fieldsList[idx] = address;
              handleChange([...fieldsList]);
            }}
          />
          {idx >= 0 && (
            <div className="w-full">
              <Button
                type={ButtonTypes.remove}
                text="Remove"
                colorType={ButtonColorTypes.negativeAction}
                onClick={(e) => handleRemove(e, idx)}
                className="mt-4 px-0"
              />
            </div>
          )}
          <Divider className="mb-6" />
        </div>
      ))}
      <Button
        type={ButtonTypes.add}
        text="Add Address"
        colorType={
          alternateColor ? ButtonColorTypes.alternate : ButtonColorTypes.action
        }
        onClick={handleAdd}
      />
    </>
  );
};

export default PersonFormAddresses;
